import { activateLoading, deactivateLoading } from './GlobalSlice';
import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { TFinancialInfoTabs } from '../../Pages/FinancialInfo/FinancialInfo.type';
import { fetchAllReports, fetchReportData, fetchReportId, fetchTaxForm, fetchTaxForms } from '../APIServices/FinancialInfoService';

export interface IFinancialInfoState {
  allReports: any;
  taxForms: any;
  financialInfoSectionSelectedTab: TFinancialInfoTabs[];
}

export const initialFinancialInfoState: IFinancialInfoState = {
  allReports: {},
  taxForms: {},
  financialInfoSectionSelectedTab: []
};

const initialState: IFinancialInfoState = { ...initialFinancialInfoState };

export const financialInfoSlice = createSlice({
  name: 'FinancialInfo',
  initialState,
  reducers: {
    updateFinancialInfoSectionSelectedTab: (
      state,
      action: PayloadAction<TFinancialInfoTabs[]>
    ) => {
      state.financialInfoSectionSelectedTab = action?.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllReports.fulfilled, (state, action) => {
      if (action?.payload) {
        state.allReports = action?.payload;
      }
    });
    builder.addCase(getTaxForms.fulfilled, (state, action) => {
      if (action?.payload) {
        state.taxForms = action?.payload;
      }
    });
  },
});

export const {
  updateFinancialInfoSectionSelectedTab
} = financialInfoSlice.actions;

export default financialInfoSlice.reducer;

export const getAllReports = createAsyncThunk(
  "FinancialInfo/getAllReports",
  async (payLoad: any, { dispatch }) => {
    dispatch(activateLoading());
    const response: any = await fetchAllReports(payLoad);
    dispatch(deactivateLoading());
    return response
  }
);

export const getTaxForms = createAsyncThunk(
  "FinancialInfo/getTaxForms",
  async (payLoad: any, { dispatch }) => {
    dispatch(activateLoading());
    const response: any = await fetchTaxForms(payLoad);
    dispatch(deactivateLoading());
    return response;
  }
);

export const getReportId = createAsyncThunk(
  "FinancialInfo/getReportId",
  async (payLoad: any, { dispatch }) => {
    dispatch(activateLoading());
    const response: any = await fetchReportId(payLoad);
    dispatch(deactivateLoading());
    return response
  }
);

export const getReportData = createAsyncThunk(
  "FinancialInfo/getReportData",
  async (payLoad: any, { dispatch }) => {
    dispatch(activateLoading());
    const response: any = await fetchReportData(payLoad);
    dispatch(deactivateLoading());
    return response
  }
);

export const getTaxForm = createAsyncThunk(
  "FinancialInfo/getTaxForm",
  async (payLoad: any, { dispatch }) => {
    dispatch(activateLoading());
    const response: any = await fetchTaxForm(payLoad);
    dispatch(deactivateLoading());
    return response
  }
);